module.exports = {
	"articleTitle1": "Professors discuss Monday's colloquium and diversity in the League ...",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Michigan League",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/league-women-voters-talks-redistricting-polarization",
	"articleSnippet1": "Feb 2, 2017 ... Following Justice Sonia Sotomayor's and German Justice Susanne Baer's \nbicentennial colloquium discussion on Monday, three University of ...",
	"articleSnippet2": "Nov 5, 2015 ... Susan Smith of the League of Women Voters speaks on legislation regarding \ndistrict lines and the future of redistricting in Michigan at Weill Hall ...",
	"totalMisc": 0,
	"articleTitle2": "League of Women Voters talks redistricting, polarization ",
	"address": "911 N University Ave, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161104/ahz.NEW_.DisruptingDemocracy.11.1.160398.jpg?itok=7aCbr8i9",
			"author": "Arnold Zhou",
			"caption": "Engineering Prof. Alex Halderman and Political Science Prof. Walter Mebane discuss the influence of technology in elections on a panel moderated by Michigan Radio Host Doug Tribou in the Michigan League on Tuesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160212/del.NEW_.sexpertise.2.11.16089_0.jpg?itok=_V5SnaO6",
			"author": "Delaney Ryan",
			"caption": "LSA freshman Peyton Watt plays games and participates in sex positive themed activities in a carnival at the 8th annual Sexpertise at the Michigan League on Thursday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160310/mjv.NEW_.SlamPoetry.3.11.16.026.jpg?itok=1Eu882GS",
			"author": "Matt Vailliencourt",
			"caption": "LSA sophomore Laura Schwendeman performs a poem as a part of Michigan's slam poetry team at the Michigan League on Thursday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160322/eaa.FEA_.HipHopSummit.3.19.16.003.jpg?itok=KQq9ysTV",
			"author": "Evan Aaron",
			"caption": "A performer from Element 1 breakdances at the Hip Hop summit at the Michigan League on Saturday."
		}
	],
	"position": {
		"lat": 42.279051,
		"lng": -83.737653
	},
	"tips": [
		{
			"text": "Ther are some pretty good food options here for anyone looking for a quick bite.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "1st Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/league.json
// module id = 906
// module chunks = 0